import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _process$env$NEXT_PUB, _process$env$NEXT_PUB2, _process$env$NEXT_PUB3, _process$env$NEXT_PUB4;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useMemo } from 'react';
import { IntercomProvider, useIntercom } from 'react-use-intercom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { FacebookProvider } from 'react-facebook';
import { ToastContainer } from 'react-toastify';
import { useRouter } from 'next/router';
import { ReactQueryWrapper, ServiceProvider } from '@restworld/data-services';
import { AuthProvider, tokenKeyName, useAuth } from '@restworld/feature-authentication';
import { GlobalOptionsFetchingProvider, UTMSourceProvider, ToastMessageContextProvider, AnalyticsProvider } from './';
import { IubendaProvider } from './iubenda';
import { defaultToastConfig } from '../constants/default-toast-config';
import { useIsEmployerApp } from '../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var baseUrl = (_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_BASE_API_URL) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : '';
var INTERCOM_APP_ID = (_process$env$NEXT_PUB2 = process.env.NEXT_PUBLIC_INTERCOM_APP_ID) !== null && _process$env$NEXT_PUB2 !== void 0 ? _process$env$NEXT_PUB2 : '';
var googleClientId = (_process$env$NEXT_PUB3 = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID) !== null && _process$env$NEXT_PUB3 !== void 0 ? _process$env$NEXT_PUB3 : '';
var facebookAppId = (_process$env$NEXT_PUB4 = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID) !== null && _process$env$NEXT_PUB4 !== void 0 ? _process$env$NEXT_PUB4 : '';
export var MainContext = function MainContext(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(ReactQueryWrapper, {
    children: /*#__PURE__*/_jsx(AuthProvider, {
      baseUrl: baseUrl,
      children: /*#__PURE__*/_jsx(ServiceProviderWrapper, {
        children: /*#__PURE__*/_jsx(IubendaProvider, {
          children: /*#__PURE__*/_jsx(GoogleOAuthProvider, {
            clientId: googleClientId,
            children: /*#__PURE__*/_jsx(FacebookProvider, {
              appId: facebookAppId,
              children: /*#__PURE__*/_jsx(IntercomServiceProvider, {
                children: /*#__PURE__*/_jsx(AnalyticsProvider, {
                  children: /*#__PURE__*/_jsx(UTMSourceProvider, {
                    children: /*#__PURE__*/_jsxs(GlobalOptionsFetchingProvider, {
                      children: [/*#__PURE__*/_jsx(ToastMessageContextProvider, {
                        children: children
                      }), /*#__PURE__*/_jsx(ToastContainer, _objectSpread({}, defaultToastConfig))]
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};
export var IntercomServiceProvider = function IntercomServiceProvider(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_jsx(IntercomProvider, {
    appId: INTERCOM_APP_ID,
    initializeDelay: 500,
    children: /*#__PURE__*/_jsx(IntercomInitiation, {
      children: children
    })
  });
};

var IntercomInitiation = function IntercomInitiation(_ref3) {
  var children = _ref3.children;

  var _useIntercom = useIntercom(),
      boot = _useIntercom.boot,
      shutdown = _useIntercom.shutdown;

  var _useAuth = useAuth(),
      user = _useAuth.user;

  var router = useRouter();

  var _useIsEmployerApp = useIsEmployerApp(),
      isEmployerApp = _useIsEmployerApp.isEmployerApp;

  var autoBootProps = useMemo(function () {
    if (user) {
      var userHash = user.organization_id,
          userId = user.id,
          imageUrl = user.picture,
          phoneNumber = user.phone_number,
          insertedAt = user.inserted_at,
          name = user.name,
          email = user.email;
      return _objectSpread(_objectSpread({
        userId: userId,
        phone: phoneNumber,
        avatar: {
          type: 'avatar',
          imageUrl: imageUrl
        },
        userHash: userHash,
        // Current user's company id
        createdAt: insertedAt
      }, user), {}, {
        name: name,
        email: email,
        hideDefaultLauncher: isEmployerApp
      });
    } else return {
      hideDefaultLauncher: router.pathname.includes('/locale') || router.pathname.includes('/worker/file-complaint')
    };
  }, [isEmployerApp, router.pathname, user]);
  useEffect(function () {
    if (true) boot(_objectSpread({}, autoBootProps));
    return function () {
      shutdown();
    };
  }, [autoBootProps, boot, shutdown]); // eslint-disable-next-line react/jsx-no-useless-fragment

  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};

export var ServiceProviderWrapper = function ServiceProviderWrapper(_ref4) {
  var children = _ref4.children;

  var _useAuth2 = useAuth(),
      token = _useAuth2.jwt;

  var jwt = token || typeof localStorage !== 'undefined' ? localStorage.getItem(tokenKeyName) : '';
  return /*#__PURE__*/_jsx(ServiceProvider, {
    baseUrl: baseUrl,
    jwt: jwt,
    children: children
  });
};